var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4.483 11.992l-3.233.758.759-3.232 7.973-7.975a1 1 0 011.415 0l1.06 1.06a1 1 0 010 1.415l-7.974 7.974z",
    stroke: "currentColor",
    strokeWidth: 0.583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.105 4.373L9.629 1.897m1.763 3.189L8.92 2.604m-4.311 9.263L2.134 9.392",
    stroke: "currentColor",
    strokeWidth: 0.583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjQ4MyAxMS45OTJsLTMuMjMzLjc1OC43NTktMy4yMzIgNy45NzMtNy45NzVhMSAxIDAgMCAxIDEuNDE1IDBsMS4wNiAxLjA2YTEgMSAwIDAgMSAwIDEuNDE1bC03Ljk3NCA3Ljk3NHoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9Ii41ODMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjxwYXRoIGQ9Ik0xMi4xMDUgNC4zNzNMOS42MjkgMS44OTdtMS43NjMgMy4xODlMOC45MiAyLjYwNG0tNC4zMTEgOS4yNjNMMi4xMzQgOS4zOTIiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9Ii41ODMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjwvc3ZnPg==";
export { SvgPencil as ReactComponent };